export default __webpack_public_path__ + "static/rabbi-icon-d31bb64aba64843999bc878bcc2587a8.png";